import styled from 'styled-components';
import { FormItem } from '@/components';

export const CompanyFields = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1rem;
  min-width: 0;
`;

export const CompanyRow = styled.div`
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 1rem;

  @media (max-width: 359px) {
    grid-template-columns: minmax(0, 1fr);
  }
`;

export const TaxTypeFormItem = styled(FormItem)`
  .ant-form-item-explain {
    padding-top: 6px;
  }
`;
